export default "__VITE_ASSET__CMSQIY9K__"